<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="orange"
          title="Customers"
          text="Number of accounts per customer"
        >
          <v-layout
            wrap>
            <v-flex
              xs12
              sm3
              md3>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="customerHeaders"
            :items="customerAccounts"
            :search ="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              v-slot:items="props">
              <td>
                <router-link
                  :to="'/admin/account-inventory/customers/'+ props.item.Customer_Id">
                  {{ props.item.Customer_Name }}
                </router-link>
              </td>
              <td>{{ props.item.No_of_Accts }}</td>
            </template>
          </v-data-table>
          <v-progress-linear
            v-if="loadingCustomerAccounts"
            v-slot:progress
            color="orange"
            indeterminate/>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data: () => ({
    loader: null,
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      sortBy: 'Customer_Name'
    }
  }),
  mounted() {
    console.log('by CUSTOMER')
    
    this.$store.dispatch('admin/accountInventory/getNumberOfAccountsByCustomer')
  },
  computed: {
    ...mapState('admin/accountInventory', ['customers', 'customerHeaders', 'customerAccounts', 'loadingCustomerAccounts']),
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}
.v-btn .v-btn__content {
  color: rgba(0, 0, 0, 0.87);
  background-color: none;
  box-shadow: none;
  font-weight: 500;
}
#data-link {
  background-color: none;
  box-shadow: none;
  padding: 0;
  font-weight: 600;
}
.masterDropdown{
  margin-bottom:0 ;
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot{
  background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
  color:#fff !important;
}
.theme--light.v-select .v-select__selections{
  color:#fff !important;
}
  .theme--light.v-icon{
    color:#fff;
  }
}

</style>
